export class ResponseCartOneTimeFeeModel {
    oneTimeFeeName: string;
    unitPrice: number;
    currencyCode: string;
}
